import * as React from "react";
import moment from "moment";

import { StyledCard, Content, Column } from "./SummaryInfo.styles";
import { currentUser, getTeacherLinkedSchool } from "../../../common/services";

interface IProps {
  data?: any;
  isParent?: boolean;
  isSchool?: boolean;
  isTeacher?: boolean;
}

class SummaryInfo extends React.Component<IProps> {
  public state = {};

  constructor(props) {
    super(props);
  }

  public renderStudentInfo() {
    const { data } = this.props;
    const { name, school, birth_day, courses_taken } = data;
    const age = moment().diff(birth_day, "years");
    const numberOfCourses = courses_taken.length;

    return (
      <StyledCard>
        <h4>{name}</h4>
        <Content>
          <Column>
            <h3>School</h3>
            <p>{school}</p>
          </Column>

          <Column>
            <h3>Number of courses taken</h3>
            <p>{numberOfCourses}</p>
          </Column>
        </Content>
      </StyledCard>
    );
  }

  public renderParentInfo() {
    const { data } = this.props;
    const { Name, NumberOfStudents, CoursesAvailable } = data;
    const numberOfCourses = CoursesAvailable.length;

    return (
      <StyledCard>
        <h4>{Name}</h4>
        <Content>
          <Column>
            <h3>School</h3>
            <p>N/A</p>
          </Column>
          <Column>
            <h3>Number of Students</h3>
            <p>{NumberOfStudents}</p>
          </Column>
          <Column>
            <h3>Number of courses available</h3>
            <p>{numberOfCourses}</p>
          </Column>
        </Content>
      </StyledCard>
    );
  }

  public renderTeacherInfo() {
    const { data } = this.props;
    const { available_courses } = data;
    const numberOfCourses = available_courses.length;

    return (
      <StyledCard>
        <h4>{currentUser()}</h4>
        <Content>
          <Column style={{ gridColumnStart: "1", gridColumnEnd: "3" }}>
            <h3>School</h3>
            <p>{getTeacherLinkedSchool()}</p>
          </Column>
          {/* <Column>
            <h3>Number of Students</h3>
            <p>0</p>
          </Column> */}
          <Column>
            <h3>Number of courses available</h3>
            <p>{numberOfCourses}</p>
          </Column>
        </Content>
      </StyledCard>
    );
  }

  public renderSchoolInfo() {
    const { data } = this.props;
    console.log({ data });
    const { Name, NumberOfStudents, CoursesAvailable, available_courses } =
      data;
    const numberOfCourses = available_courses.length;

    return (
      <StyledCard title="Summary">
        <Content>
          <Column>
            <h3>School</h3>
            <p>{Name}</p>
          </Column>
          <Column>
            <h3>Number of Students</h3>
            <p>{NumberOfStudents}</p>
          </Column>
          <Column>
            <h3>Number of courses available</h3>
            <p>{numberOfCourses}</p>
          </Column>
        </Content>
      </StyledCard>
    );
  }

  public render() {
    const { isParent, isSchool, isTeacher } = this.props;

    if (isParent) {
      return this.renderParentInfo();
    }
    if (isSchool) {
      return this.renderSchoolInfo();
    }
    if (isTeacher) {
      return this.renderTeacherInfo();
    }

    return this.renderStudentInfo();
  }
}

export default SummaryInfo;



// WEBPACK FOOTER //
// ./src/components/DataCentre/SummaryInfo/SummaryInfo.tsx